import PropTypes from 'prop-types';

import { useFormState } from 'utils/hooks';
import ShadowBox from 'common/components/general/ShadowBox';
import CircledButton from 'common/components/buttons/CircledButton';
import { FormState } from 'common/entities/form/FormTypes';
import Fields from './Fields';
import Header from '../components/Header';

const Rules = ({ formState, label, title, isEditDisabled }) => {
  const { subStates, addSubform, removeSubform } = useFormState(formState);

  const ruleState = subStates(label);

  return (
    <ShadowBox
      className="pt-1 pb-2 cps-12 cpe-12 w-100p h-100p d-flex flex-column mb-1"
      color="light-1"
      flat
    >
      <Header title={title} label={label} />

      {ruleState?.map((ruleState, index) => (
        <Fields
          key={index}
          showHeader={index === 0}
          formState={ruleState}
          label={label}
          onRemove={() => removeSubform(label, index)}
          isEditDisabled={isEditDisabled}
        />
      ))}

      {isEditDisabled ? null : (
        <CircledButton
          type="add"
          label="Add more"
          onClick={() => addSubform(label)}
          svgStyle={{ width: 8, height: 8 }}
          style={{ width: 15, height: 15 }}
          className="fs-12 align-self-start mt-2"
        />
      )}
    </ShadowBox>
  );
};

export default Rules;

Rules.propTypes = {
  formState: FormState,
  label: PropTypes.string.isRequired,
  title: PropTypes.string,
  isEditDisabled: PropTypes.bool
};
